import React from 'react';

import { faWarning } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Dialog, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export interface ConfirmationDialogLabels {
    title: string;
    confirmText: string;
    cancelText: string;
}

interface ConfirmationDialogProps {
    open: boolean;
    labels: ConfirmationDialogLabels;
    children: React.ReactNode;
    onConfirm: () => void;
    onClose: () => void;
}

function ConfirmationDialog({
    open,
    labels,
    children,
    onConfirm,
    onClose,
}: ConfirmationDialogProps) {
    const { palette } = useTheme();

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>
                <Stack sx={{ gap: 1 }}>
                    <FontAwesomeIcon icon={faWarning} color={palette.red[900]} size="2x" />
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        {labels.title}
                    </Typography>
                </Stack>
            </DialogTitle>
            <DialogContent sx={{ p: 2.5 }}>
                <Stack sx={{ gap: 4 }}>
                    <Typography variant="body1">{children}</Typography>
                    <Stack sx={{ gap: 2.5 }}>
                        <Button
                            variant="outlined"
                            color="error"
                            disableElevation
                            onClick={onConfirm}
                        >
                            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                {labels.confirmText}
                            </Typography>
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            disableElevation
                            onClick={onClose}
                        >
                            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                {labels.cancelText}
                            </Typography>
                        </Button>
                    </Stack>
                </Stack>
            </DialogContent>
        </Dialog>
    );
}

export default ConfirmationDialog;
